import { actions } from "./action";

const initialState = {
  user: null,
  error: "",
  refreshToken: null,
  token: null,
  // Password accepted, second step outstanding. Held in memory only.
  mfa: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.USER_REGISTRATION_SUCCESS:
      return {
        ...state,
        user: action.payload,
      };
    case actions.USER_LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload,
      };
    case actions.USER_DETAIL_SUCCESS:
      return {
        ...state,
        user: action.payload,
      };
    case actions.USER_UPDATE_SUCCESS:
      return {
        ...state,
        user: action.payload,
      };
    case actions.USER_UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        user: action.payload,
      };
    case actions.USER_LOGOUT_SUCCESS:
      return {
        ...state,
        user: [],
        error: "",
      };
    case actions.USER_REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        refreshToken: action.payload.refreshToken,
        token: action.payload.token,
      };
    case actions.USER_MFA_PENDING:
      return {
        ...state,
        mfa: action.payload,
      };
    case actions.USER_MFA_CLEAR:
      return {
        ...state,
        mfa: null,
      };
    case actions.CATCH_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default userReducer;
